import { MouseEvent } from 'react';
import { TrackingService } from '@rocheglobal/component-library-dot-com/src/services/tracking';
import { AdobeTracking } from '../../tracking-services';
import { RocheUIButtonType } from '@repo/roche-ui';
import { DefaultLinkClickData } from '../../tracking-services/types';

export const createRocheButtonTrackingObject = (text: string, href?: string): DefaultLinkClickData => {
  return {
    innerText: text,
    url: href,
    position: 'RocheButton',
    type: RocheUIButtonType.BUTTON,
    socialMedia: '',
    socialInteraction: '',
  };
};

export const handleRocheButtonOnClick = (_clickEvent: MouseEvent, trackingData: DefaultLinkClickData) => {
  const adobeTrackingObject = trackingData;
  const additionalParameters: { click_text?: string; click_url?: string; button_label?: string } = {};
  const defaultTracking = {
    event: trackingData.url ? 'link_click' : 'button_click',
    component_name: 'roche-button',
  };

  if (trackingData.url) {
    additionalParameters.click_text = trackingData.innerText;
    additionalParameters.click_url = trackingData.url;
  } else {
    additionalParameters.button_label = trackingData.url;
  }

  TrackingService.push({
    ...defaultTracking,
    additionalParameters: {
      ...additionalParameters,
      // TODO: see: https://roche-ds.atlassian.net/browse/EXTCWP-701.
      // ...TrackingService.getParentAwareTrackingInfo(event),
    },
  });

  AdobeTracking(adobeTrackingObject, 'defaultLinkClick');
};
